// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contractPartyEntity from './entities/contract-party.json';
import contractPartyMenu from '../pages/contract-party/menu.json';
import contractPartyFullForm from '../pages/contract-party/forms/full.json';
import contractPartyContextForm from '../pages/contract-party/forms/context.json';
import contractPartyMiniForm from '../pages/contract-party/forms/mini.json';
import contractPartyLookupForm from '../pages/contract-party/forms/lookup.json';
import contractPartyTableView from '../pages/contract-party/views/table.json';
import contractPartyCardsView from '../pages/contract-party/views/cards.json';
import contractPartyDashboardView from '../pages/contract-party/views/dashboard.json';

/** Тип запису «Сторона договору» зі сторінками пакета: меню, форми та подання з pages/contract-party/. */
export const contractPartyDefinition: IRecordTypeDefinition = {
  ...contractPartyEntity,
  views: assembleViewSet({
      table: contractPartyTableView,
      cards: contractPartyCardsView,
      dashboard: contractPartyDashboardView,
  }),
  form: contractPartyFullForm,
  forms: { full: contractPartyFullForm, context: contractPartyContextForm, mini: contractPartyMiniForm, lookup: contractPartyLookupForm },
  menu: contractPartyMenu,
} as IRecordTypeDefinition;
